module.exports = __webpack_public_path__ + "img/star-white-big.99cb49c8.svg";